/*
 * Persist the active detail-page tab in the URL hash, so a reload (or a shared
 * link) restores the same tab. This brings back the Bootstrap 3 behavior where
 * selecting a tab put "#tab-foo" in the URL — Bootstrap 5 native tabs no longer
 * do this on their own.
 *
 * Scoped to the TabGroup markup rendered by tabs/tab-view.html (.tabs-wrapper)
 * so it doesn't fight pages that manage their own tab hash (e.g. misc settings).
 */
(function (c2, $) {
  'use strict';

  var SEL = '.tabs-wrapper .nav-boxed-tabs [data-bs-toggle="tab"]';

  // localStorage key for remembering the last active tab on this page path.
  function storageKey() {
    return 'c2.tabs.active.' + window.location.pathname;
  }

  function targetOf(link) {
    return link.getAttribute('data-bs-target') || link.getAttribute('href') || '';
  }

  // Activate the tab whose pane matches the given hash (e.g. "#build").
  function activate(hash) {
    if (!hash || hash.charAt(0) !== '#' || hash.length < 2) return false;
    if (!window.bootstrap || !bootstrap.Tab) return false;
    var id = hash.slice(1);
    var esc = (window.CSS && CSS.escape) ? CSS.escape(id) : id;
    var link = document.querySelector(
      SEL + '[data-bs-target="#' + esc + '"], ' + SEL + '[href="#' + esc + '"]'
    );
    if (!link) return false;
    try {
      bootstrap.Tab.getOrCreateInstance(link).show();
      return true;
    } catch (e) {
      return false;
    }
  }

  function init() {
    var links = document.querySelectorAll(SEL);
    if (!links.length) return;

    // Reflect the active tab in the URL hash (no scroll / no history spam) and
    // remember it per-path in localStorage.
    links.forEach(function (link) {
      link.addEventListener('shown.bs.tab', function (e) {
        var target = targetOf(e.target);
        if (target.charAt(0) === '#') {
          history.replaceState(null, '', location.pathname + location.search + target);
          try { localStorage.setItem(storageKey(), target.slice(1)); } catch (err) { /* ignore */ }
        }
      });
    });

    // On load, the URL hash has the most authority (shareable / explicit);
    // otherwise fall back to the last tab remembered for this path.
    if (!activate(location.hash)) {
      var saved = '';
      try { saved = localStorage.getItem(storageKey()) || ''; } catch (err) { /* ignore */ }
      if (saved) { activate('#' + saved); }
    }

    // Follow back/forward hash navigation.
    window.addEventListener('hashchange', function () {
      activate(location.hash);
    });
  }

  c2.tabs = { init: init, activate: activate };

  $(function () {
    init();
  });
})(window.c2 = window.c2 || {}, window.jQuery);
